import classNames from "classnames";

// assets
import styles from "@/assets/styles/components/skeleton.module.scss";

const SkeletonInput = ({ className }: { className: string }) => {

  return (
    <div className={classNames(
      styles["ant-skeleton"],
      styles["ant-skeleton-element"],
      styles["ant-skeleton-active"],
      styles["ant-skeleton-block"],
      className,
    )}>
      <span className={classNames(
        styles["ant-skeleton-input"],
        classNames
      )}></span>
    </div>
  )
}

export default SkeletonInput;
